import { render } from "./ModalWithdrawBtc.vue?vue&type=template&id=efaa320e&scoped=true&ts=true"
import script from "./ModalWithdrawBtc.vue?vue&type=script&lang=ts"
export * from "./ModalWithdrawBtc.vue?vue&type=script&lang=ts"

import "./ModalWithdrawBtc.vue?vue&type=style&index=0&id=efaa320e&lang=stylus&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efaa320e"]])

export default __exports__